import React, { FC } from 'react';
import ReactCountryFlag from 'react-country-flag';

import { COUNTRY_FLAGS_API } from '../../constants';
import { CountryFlagProps } from './CountryFlag.types';

const CountryFlag: FC<CountryFlagProps> = ({ countryCode }) => (
  <ReactCountryFlag svg cdnUrl={COUNTRY_FLAGS_API} countryCode={countryCode} />
);

export default CountryFlag;
